module.exports = __webpack_public_path__ + "img/logo_european.2d4461b8.png";